var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktokinline = function SvgTiktokinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.838 4.011-.002-.002A4.791 4.791 0 0 1 12.657 0H9.219l-.005 13.78a2.89 2.89 0 0 1-2.885 2.78 2.891 2.891 0 0 1-2.89-2.89 2.893 2.893 0 0 1 2.89-2.89c.297 0 .582.05.853.135v-3.51a6.3 6.3 0 0 0-.853-.063A6.337 6.337 0 0 0 0 13.671c0 2.14 1.07 4.036 2.703 5.181A6.296 6.296 0 0 0 6.33 20c3.49 0 6.328-2.84 6.328-6.328V6.683a8.18 8.18 0 0 0 4.784 1.539V4.783c-.925 0-1.83-.268-2.603-.773l-.001.001Z",
    fill: "currentColor"
  })));
};
export default SvgTiktokinline;